var helper = /** @class */ (function () {
    function helper() {
    }
    helper.random = function () {
        return (Math.random() * (new Date().getTime() || 1)) % 1;
    };
    helper.newGuid = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) { var r = helper.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8; return v.toString(16); });
    };
    helper.newSeqGuid = function () {
        var d = new Date().getTime().toString(16);
        while (d.length < 12) {
            d = "0" + d;
        }
        if (d.length > 12) {
            d = d.substring(0, 12);
        }
        return "xxxxxxxx-xxxx-4xxx-yxxx-".replace(/[xy]/g, function (c) { var r = helper.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8; return v.toString(16); })
            + d;
    };
    helper.newDomGuid = function () {
        return "axxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) { var r = helper.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8; return v.toString(16); });
    };
    helper.isObject = function (obj) {
        return obj ? Object.prototype.toString.call(obj) === "[object Object]" : false;
    };
    helper.isGuid = function (id) {
        if (!id) {
            return false;
        }
        return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(id);
    };
    helper.getParams = function () {
        var match, pl = /\+/g, // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g, decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); }, query = window.location.search.substring(1);
        var urlParams = {};
        while (match = search.exec(query))
            urlParams[decode(match[1])] = decode(match[2]);
        return urlParams;
    };
    helper.isCyclic = function (o) {
        var seenObjects = [];
        function detect(obj) {
            if (obj && typeof obj === 'object') {
                if (seenObjects.indexOf(obj) !== -1) {
                    return true;
                }
                seenObjects.push(obj);
                for (var key in obj) {
                    if (obj.hasOwnProperty(key) && detect(obj[key])) {
                        return true;
                    }
                }
            }
            return false;
        }
        return detect(o);
    };
    helper.correctDates = function (data) {
        for (var key in data) {
            if (data[key] && typeof data[key] === "object")
                data[key] = helper.correctDates(data[key]);
            //else if (data[key] && data[key].toString().substring(0, 6) === "/Date\(")
            //    data[key] = new Date(parseInt(data[key].substr(6))+ timezone_offset);
            else if (data[key] && dateISO.test(data[key].toString())) {
                var x = Date.fromString(data[key]);
                data[key] = new Date(x.getTime() + (x.getTimezoneOffset() * 60000));
            }
        }
        return data;
    };
    helper.isTouchScreen = function () {
        return ("ontouchstart" in window) || (navigator.msMaxTouchPoints > 0);
    };
    helper.emptyGuid = "00000000-0000-0000-0000-000000000000";
    return helper;
}());
export { helper };
var dateISO = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*/i;
(function () {
    var d = window.Date;
    var regexIso8601 = /^(\d{4})-(\d{2})-(\d{2})((T)(\d{2}):(\d{2})(:(\d{2})(\.\d*)?)?)?(Z)?$/;
    d._myparse = function (v) {
        if (v.charAt(v.length - 1) !== "Z")
            v += "Z";
        var m = regexIso8601.exec(v);
        if (m) {
            return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[6] || 0, +m[7] || 0, +m[9] || 0, parseInt((+m[10]) * 1000) || 0));
            //return Date.UTC(
            //    m[1],
            //    (m[2] || 1) - 1,
            //    m[3] || 1,
            //    m[4] - (m[8] ? m[8] + m[9] : 0) || 0,
            //    m[5] - (m[8] ? m[8] + m[10] : 0) || 0,
            //    m[6] || 0,
            //    ((m[7] || 0) + '00').substr(0, 3)
            //);
        }
        return d.parse.apply(this, arguments);
    };
    d.fromString = function (v) {
        return d._myparse(v);
    };
})();
